import { FC } from "react";
import PolicyContentInputContainer from "./Container";
import { TextInput } from "djinn-components";
import ReactQuill from "react-quill";
import { PolicyBuilderContentItem } from "../../../types/api";

export const ItemTypes = {
  CARD: "card",
};
export interface CardProps {
  id: any;
  index: string | number;
  card: PolicyBuilderContentItem;
  updateCard: (value: PolicyBuilderContentItem) => void;
  deleteCard: () => void;
}

export const Card: FC<CardProps> = ({
  card,
  index,
  updateCard,
  deleteCard,
}) => {
  return (
    <div className="w-full rounded-lg p-4 mb-3 bg-gray-800 bg-opacity-25 border border-gray-500">
      <TextInput
        value={card.title}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          updateCard({ ...card, title: e.currentTarget.value })
        }
        placeholder="Section Title"
        className="shadow-md border border-gray-600"
      />
      <div className="quileditor bg-gray-600 rounded-lg overflow-hidden focus-within:border-white border border-gray-600 my-4">
        <ReactQuill
          value={card.content}
          onChange={(v: any) => updateCard({ ...card, content: v })}
        />
      </div>

      <PolicyContentInputContainer
        value={card.items}
        index={index}
        onChanged={(v: PolicyBuilderContentItem[]) =>
          updateCard({ ...card, items: v })
        }
        deleteItem={deleteCard}
      />
    </div>
  );
};
